import "trumbowyg/dist/trumbowyg";

export default function setup() {
    $(document).ready(function () {
        $('.rich-text-editor').trumbowyg();
    })
    $.trumbowyg.svgPath = "/js/ui/icons.svg";
}